import { ImagenesSatelitalesState } from '@/store/modules/imagenes-satelitales/types'
import { PronosticoMeteorologicoState } from '@/store/modules/pronostico-meteorologico/types'
import { PronosticoLocalMapasState } from '@/store/modules/pronostico-local-mapas/types'
import Vue from 'vue'

const preloadImages = (baseUrl: string, apiObject: ImagenesSatelitalesState | PronosticoMeteorologicoState | PronosticoLocalMapasState) => {
  if (apiObject.pasos > 0) {
    const images: string [] = Object.keys(apiObject.imagenes).map((type: string) => {
      // @ts-ignore
      return apiObject.imagenes[type].map((image: string) => `${baseUrl}${apiObject.ruta}/${image}`)
    }).flat()
    Vue.preGroup({
      image: images
    }, 'prefetch')
  }
}

export { preloadImages }
